import React from 'react';
import { CheckLine } from '@archipro-design/icons';
import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import * as S from './PaintPickerSavePaletteEmptyModal.style';

interface PaintPickerSavePaletteEmptyModalProps {
    onDismiss: () => void;
}

export const PaintPickerSavePaletteEmptyModal = ({
    onDismiss,
}: PaintPickerSavePaletteEmptyModalProps) => {
    const { desktop } = useAppDisplayModeContext();
    const { css } = useStyles({ desktop });

    return (
        <div className={css(S.Container)}>
            <div className={css(S.Title)}>
                Please add a colour to your palette
            </div>
            <div className={css(S.Text)}>
                Create a Palette by using the Colour Selector to add one or more
                Paint Colours
            </div>
            <div className={css(S.Button)} onClick={onDismiss}>
                <div className={css(S.ButtonLabel)}>Got it</div>
                <div>
                    <CheckLine />
                </div>
            </div>
        </div>
    );
};
